import styled from 'styled-components';

export const StyledLessonPlans = styled.div`
	width: 100%;

	.editor-wrapper {
		margin-bottom: var(--spacing-4);
		padding-bottom: var(--spacing-4);
	}

	.more-option-wrapper {
		margin-bottom: var(--spacing-4);
	}
`;

export const StyledLessonPlanFooter = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
`;

export const StyledLessonsPlaceholder = styled.div`
	color: var(--body-text);
	padding: var(--spacing-4);
	width: 100%;
`;
